export const VALIDATOR_MESSAGES = {
    usuario: [
      { type: 'required', message: 'Se requiere nombre de usuario.' },
      { type: 'minlength', message: 'Debe tener al menos 6 caracteres.' },
      { type: 'maxlength', message: 'No puede tener más de 30 caracteres.' },
      { type: 'pattern', message: 'Ingrese un nombre de usuario válido.' },
      { type: 'existingUsername', message: 'El usuario ya se encuentra registrado.' },
      { type: 'existingUsuarioAuth', message: 'El usuario ya se encuentra registrado.' }
    ],
    clave: [
      { type: 'required', message: 'Se requiere contraseña.' },
      { type: 'minlength', message: 'debe contener 6 caracteres como mínimo.' },
      { type: 'pattern', message: 'Ingrese una contraseña válida.' },
      { type: 'equalTo', message: 'Las contraseñas no coinciden.' },
    ],
    password: [
      { type: 'required', message: 'Se requiere contraseña.' },
      { type: 'minlength', message: 'Debe contener 6 caracteres como mínimo.' },
      { type: 'pattern', message: 'Ingrese una contraseña válida.' },
      { type: 'existingPassword', message: 'El password es incorrecto.' },
    ],
    nombres: [
      { type: 'required', message: 'Se requiere los nombres.' },
      { type: 'minlength', message: 'El nombre debe tener minimo 3 caracteres.' },
      { type: 'maxlength', message: 'El nombre debe tener maximo 50 digitos.' },
    ],
    apellidos: [
      { type: 'required', message: 'Se requiere los apellidos.' },
      { type: 'minlength', message: 'El nombre debe tener minimo 3 caracteres.' },
      { type: 'maxlength', message: 'El nombre debe tener maximo 50 digitos.' },
    ],
    nombrecompleto: [
      { type: 'required', message: 'Se requiere nombres y apellidos del usuario.' },
      { type: 'minlength', message: 'El nombre debe tener al menos 5 caracteres.' },
    ],
    perfil: [
      { type: 'required', message: 'Se debe seleccionar un perfil.' },
    ],
    correo: [
      { type: 'required', message: 'Se requiere correo electrónico.' },
      { type: 'pattern', message: 'Ingrese un email válido.' },
      { type: 'existingEmail', message: 'El Email ya se encuentra registrado.' },
      { type: 'noExistingEmail', message: 'El Email no se encuentra registrado.' }
    ],
    sexo: [
      { type: 'required', message: 'Se debe seleccionar un género.' },
    ],
    tipodocumento: [
      { type: 'required', message: 'Se debe seleccionar un Tipo.' },
    ],
    documento: [
      { type: 'required', message: 'Se requiere el numero de documento.' },
      { type: 'minlength', message: 'Se documento requiere minimo 8 caracteres.' },
      { type: 'maxlength', message: 'No puede tener más de 20 caracteres.' }
    ],
    telefono: [
      { type: 'required', message: 'Se requiere el teléfono.' },
      { type: 'minlength', message: 'El teléfono debe tener 7 digitos.' },
      { type: 'maxlength', message: 'El teléfono debe tener 9 digitos.' },
      { type: 'pattern', message: 'Ingrese solo numeros válidos.' }
    ],
    fechanac: [
      { type: 'required', message: 'Se requiere la fecha de nacimiento.' },
      { type: 'maxlength', message: 'La fecha no puede tener más de 10 digitos.' },
      { type: 'minlength', message: 'La fecha no puede tener menos de 10 digitos.' }
    ],
    direccion: [
      { type: 'required', message: 'Se requiere la direccion.' },
      { type: 'minlength', message: 'La dirección no puede tener menos de 5 caracteres.' },
      { type: 'maxlength', message: 'La dirección no puede tener más de 250 caracteres.' }
    ],
    // accesos
    nombre: [
      { type: 'required', message: 'Se requiere el nombre.' },
      { type: 'minlength', message: 'El nombre de acceso debe tener al menos 5 caracteres.' },
      { type: 'maxlength', message: 'El nombre de acceso no puede tener más de 30 caracteres.' },
      { type: 'existingAcceso', message: 'El nombre del acceso ya se encuentra registrado.' }
    ],
    descripcion: [
      { type: 'required', message: 'Se requiere la descripcion' },
      { type: 'minlength', message: 'La descripcion debe tener al menos 5 caracteres.' },
      { type: 'maxlength', message: 'La descripcion no puede tener más de 50 caracteres.' },
    ],
    // delete-registro
    deleteregistro: [
      { type: 'required', message: 'Se requiere el identificador.' },
      { type: 'equal', message: 'El identificador no coincide.' },
    ],
    nombreperfil: [
      { type: 'required', message: 'Se requiere el nombre' },
      { type: 'minlength', message: 'El nombre debe tener al menos 5 caracteres.' },
      { type: 'maxlength', message: 'El nombre no puede tener más de 30 caracteres.' },
      { type: 'existingPerfil', message: 'El nombre ya se encuentra registrado.' }
    ],
    perfilpadre: [
      { type: 'required', message: 'Se requiere un perfil padre' },
    ],
    codigo: [
      { type: 'required', message: 'Se requiere el codigo.' },
      { type: 'minlength', message: 'Minimo 5 digitos.' },
      { type: 'maxlength', message: 'Maximo 5 digitos.' },
      { type: 'pattern', message: 'Ingrese solo numeros.' }
    ],
    razonsocial: [
      { type: 'required', message: 'Ingrese la razon social' },
      { type: 'minlength', message: 'Minimo 3 caracteres' },
      { type: 'maxlength', message: 'Maximo 250 caracteres' }
    ],
    actividad: [
      { type: 'required', message: 'Ingrese la actividad principal de la empresa' },
      { type: 'minlength', message: 'Minimo 3 caracteres' },
      { type: 'maxlength', message: 'Maximo 250 caracteres' }
  ],
  comentario: [
    { type: 'required', message: 'Se requiere un comentario.' },
    { type: 'minlength', message: 'Debe tener al menos 6 caracteres.' },
    { type: 'maxlength', message: 'No puede tener más de 100 caracteres.' }
  ],
  documento_cliente: [
    { type: 'required', message: 'Se requiere el numero de documento.' },
    { type: 'minlength', message: 'Se documento requiere minimo 8 caracteres.' },
    { type: 'maxlength', message: 'No puede tener más de 20 caracteres.' },
    { type: 'existingDocumentoCliente', message: 'Este documento ya se encuentra registrado.' }
  ],
  documento_operador: [
    { type: 'required', message: 'Se requiere el numero de documento.' },
    { type: 'minlength', message: 'Se documento requiere minimo 8 caracteres.' },
    { type: 'maxlength', message: 'No puede tener más de 20 caracteres.' },
    { type: 'existingDocumentoOperador', message: 'Este documento ya se encuentra registrado.' }
  ],
  select: [
    { type: 'required', message: 'Seleccione un opción.' },
    { type: 'minlength', message: 'Seleccione un opción.' }
  ],
  editAbonado: {
    nombre: [
      { type: 'required', message: 'Se requiere nombre del Abonado.' },
      { type: 'minlength', message: 'Debe tener al menos 5 caracteres.' },
      { type: 'maxlength', message: 'No puede tener más de 40 caracteres.' }
    ],
    direccion: [
      { type: 'required', message: 'Se requiere la dirección.' },
      { type: 'minlength', message: 'La dirección no puede tener menos de 5 caracteres.' },
      { type: 'maxlength', message: 'La dirección no puede tener más de 250 caracteres.' }
    ],
  }
};
